import { css } from 'styled-components';

const buttonDefaultStyle = () => css`
  background: none;
  border: none;
  outline: none;
  &:focus,
  &::-moz-focus-inner {
    border: none;
    outline: 2px solid black;
    outline-offset: 2px;
  }
`;
export default buttonDefaultStyle;
